import { useEffect } from 'react'

// Asks the browser to confirm before the tab is closed or reloaded while
// `active` (the form holds unsaved input and uploaded files only live in
// memory).
export const useUnloadWarning = active => {
	useEffect(() => {
		if (!active) return undefined
		const handleBeforeUnload = event => {
			event.preventDefault()
			event.returnValue = ''
		}
		window.addEventListener('beforeunload', handleBeforeUnload)
		return () => window.removeEventListener('beforeunload', handleBeforeUnload)
	}, [active])
}
